import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = [{
    icon: '⚡',
    text: 'Acceso Inmediato'
  }, {
    icon: '🇦🇷',
    text: 'Hecho para Argentinos'
  }, {
    icon: '🔒',
    text: 'Pago Seguro'
  }];
  return <section className="relative bg-black text-white overflow-hidden pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-118">
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-119">
        <div className="absolute top-[10%] left-1/2 -translate-x-1/2 w-[120%] h-[80%] rounded-full bg-amber-600/20 blur-[120px]" data-id="element-120"></div>
        <div className="absolute -bottom-1/4 left-1/2 -translate-x-1/2 w-[80%] h-[60%] rounded-full bg-amber-800/15 blur-[100px]" data-id="element-121"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-122">
        <div className="max-w-4xl mx-auto text-center mt-[-50px]" data-id="element-123">
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex gap-2 text-amber-400 font-bold tracking-wide items-center justify-center mb-6 font-[Merriweather,_serif]" data-id="element-124">
            🔨 MEGAPACK HERRERO ARGENTINO™
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="sm:text-5xl md:text-6xl lg:text-7xl font-black tracking-tight mb-10 text-amber-400 text-balance text-[18px] font-[Merriweather,_serif]" data-id="element-125">
            Del taller amateur al herrero que vive de su oficio. Desde Hoy.
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} className="relative max-w-[240px] sm:max-w-[300px] md:max-w-[380px] lg:max-w-lg mx-auto mb-10" data-id="element-126">
            <img src="https://cdn.magicpatterns.com/uploads/dfye7rhHe77BGpLcZog6w5/mockup.png" alt="MEGAPACK HERRERO ARGENTINO - 6 guías completas para aprender, crear y construir en herrería desde cero hasta nivel profesional" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(217,119,6,0.45)] mt-[-20px]" data-id="element-127" />
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="md:text-xl font-bold text-amber-400 mb-6 text-balance text-[14px] mt-[-10px] font-[Merriweather,_serif]" data-id="element-128">
            El sistema N°1 para argentinos que quieren dominar la herrería y
            convertir su taller en un negocio rentable
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-wrap justify-center mb-[30px] gap-[6px]" data-id="element-129">
            {badges.map((badge, i) => <span key={i} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-zinc-900/80 border border-amber-700/40 font-semibold backdrop-blur-sm text-[12px]" data-id="element-130">
                <span data-id="element-131">{badge.icon}</span> {badge.text}
              </span>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="mb-10" data-id="element-132">
            <button onClick={scrollToPricing} className="inline-flex items-center justify-center gap-2 px-10 py-5 rounded-2xl bg-amber-600 hover:bg-amber-500 text-white font-black uppercase tracking-wide shadow-[0_10px_40px_-10px_rgba(217,119,6,0.8)] hover:shadow-[0_15px_50px_-10px_rgba(217,119,6,0.95)] transition-all hover:-translate-y-1 md:text-base text-[12px]" data-id="element-133">
              🔥 QUIERO MI MEGAPACK AHORA
              <ArrowRight className="w-5 h-5" data-id="element-134" />
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-zinc-300 font-medium" data-id="element-135">
            <div className="flex items-center gap-1.5" data-id="element-136">
              <Shield className="w-4 h-4 text-amber-400" data-id="element-137" />
              <span data-id="element-138">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-139">
              <Lock className="w-4 h-4 text-amber-400" data-id="element-140" />
              <span data-id="element-141">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-142">
              <CreditCard className="w-4 h-4 text-amber-400" data-id="element-143" />
              <span data-id="element-144">Mercado Pago</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}